/**
 * Отложенный вход во встречу по ссылке `/m/<секрет>` (заказ владельца 2026-10-12).
 *
 * <p>Та же схема, что у {@code pendingChannelBridge}: ссылку открывают и в запущенном приложении,
 * и при холодном старте — тогда адрес приходит раньше, чем смонтирован список чатов, а у
 * человека без входа — ещё и раньше входа. Секрет ждёт подписчика и не теряется по дороге
 * через экран входа.
 */

type Listener = (token: string) => void;

let listener: Listener | null = null;
let pending: string | null = null;

/** Встреча из ссылки. Если входить пока некому — ждёт подписчика (в том числе через вход). */
export function requestJoinMeetingByLink(token: string): void {
  if (listener) {
    listener(token);
    return;
  }
  pending = token;
}

export function subscribeJoinMeetingByLink(fn: Listener): () => void {
  listener = fn;
  if (pending) {
    const t = pending;
    pending = null;
    fn(t);
  }
  return () => {
    if (listener === fn) listener = null;
  };
}
